<template>
  <div id="wrap">
    <template>
      <div class="wrapper">
        <iframe v-if="true" :src="pdfSource" frameborder="0" class="iframe" id="bdIframe"></iframe>
      </div>
    </template>
  </div>
</template>
<script>
import { api_post } from '@/utils/http'
import { myBrowser } from '@/utils/urlUtils'

export default {
  name: 'pdf',
  props: {
    pdfSource: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      src: '',
      pageCount: 0,
      numPages: null,
      version: '',
      useIframe: false
    }
  },
  computed: {
    isLowSafari: {
      get() {
        if (this.$route.query.lower) {
          return true
        } else if (myBrowser() === 'Safari') {
          let regStr_safVersion = /version\/[\d.]+/gi
          let u = navigator.userAgent
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.version = u.match(regStr_safVersion)[0].split('/')[1]
          console.log(this.version.split('.')[0])
          if (this.version.split('.')[0] < 12) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      set(value) {
        return value
      }
    },
    isLower() {
      return this.$route.query.lower || false
    }
  },
  components: {},
  watch: {
    pdfSource: {
      handler(val) {
        let temp = ''
        if (this.isLower) {
          return
        }
        console.log('bug--start')
        this.preview(val)
        console.log('bug--end')
      },
      immediate: true
    }
  },
  methods: {
    async preview(val) {
      let temp = ''
      console.log('bug--start')
      try {
        temp = pdf.createLoadingTask(val)
      } catch (e) {
        // this.isLowSafari = true
        location.href = location.pathname + location.search + `&lower=true`
      }
      this.src = temp
      this.src
        .then((pdf) => {
          this.pageCount = pdf.numPages
          console.log(this.pageCount)
        })
        .catch((e) => {
          // this.isLowSafari = true
          location.href = location.pathname + location.search + `&lower=true`
        })
    }
  },
  mounted() {
    const oIframe = document.getElementById('bdIframe')
    const deviceHeight = document.documentElement.clientHeight
    if (this.isLowSafari) {
      oIframe.style.height = Number(deviceHeight) - 120 + 'px' // 数字是页面布局高度差
    }
  }
}
</script>

<style lang="scss">
#wrap {
  font-size: 20px;
}
.wrapper {
  width: 100%;
  > span {
    width: 100%;
  }
}
.iframe {
  width: 100%;
  min-height: 600px;
}
</style>
